type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  as?: "h2" | "h3";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full">
          <i className="ri-sparkling-2-line text-sm w-4 h-4 flex items-center justify-center"></i>
          {eyebrow}
        </span>
      ) : null}
      <Heading className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
        {title}
      </Heading>
      {desc ? (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
      ) : null}
    </div>
  );
}